import sugarModule from "sugar"
import sugarInflectionsModule from "sugar-inflections"
import { MapPlus } from "library/map-plus/index.mjs"
const Sugar = sugarModule
const SugarInflections = sugarInflectionsModule

// Define the keyBy method
Sugar.Array.defineInstance({
    keyBy(array, key) {
        const original = key
        key = typeof key === "string" ? (v) => Object.get(v, original, true) : key
        return array.reduce((result, item) => {
            result[key(item)] = item
            return result
        }, {})
    },
    keyByMap(array, key) {
        const original = key
        key = typeof key === "string" ? (v) => v[original] : key
        return array.reduce((result, item) => {
            result.set(key(item), item)
            return result
        }, new Map())
    },
    groupByMap(array, key) {
        const original = key
        key = typeof key === "string" ? (v) => v[original] : key
        return array.reduce(
            (result, item) => {
                result.get(key(item)).push(item)
                return result
            },
            new MapPlus(() => [])
        )
    },
})

if (!globalThis.__sfg20SugarExtended) {
    Sugar.extend()
    globalThis.__sfg20SugarExtended = true
}

if (!globalThis.__sfg20SugarInflectionsExtended) {
    SugarInflections.extend()
    globalThis.__sfg20SugarInflectionsExtended = true
}
